import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import { USER_MUTE, USER_UNMUTE, WEB_ASSISTANT_MUTE, WEB_ASSISTANT_UNMUTE } from '../../Common/helper';
import { useSocketContext } from '../../context/SocketContext';

const ToggleComponent = ({ isVideo, socketRef, localVideoStream, recordingMute, setWebAsstSelfMute, setSelfVideoOff, localAudioTrackAgora, localVideoTrackAgora }) => {
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOff, setIsVideoOff] = useState(false);
  const { sessionIdRef } = useSocketContext();

  const toggleHandler = () => {
    if (isVideo) {
      // AGORA: Toggle video track
      if (localVideoTrackAgora) {
        if (isVideoOff) {
          localVideoTrackAgora.setEnabled(true);
          if (localVideoStream) {
            localVideoStream.getVideoTracks().forEach(track => { track.enabled = true; });
          }
        } else {
          localVideoTrackAgora.setEnabled(false);
          if (localVideoStream) {
            localVideoStream.getVideoTracks().forEach(track => { track.enabled = false; });
          }
        }
        setIsVideoOff(!isVideoOff);
        // Notify the call screen so it can show/hide the self avatar over the local video
        setSelfVideoOff?.(!isVideoOff);
      }
    } else {
      // AGORA: Toggle audio track
      if (localAudioTrackAgora) {
        if (isMuted) {
          if (socketRef && socketRef.current) {
            if (window.location.pathname.includes("webassistantcall")) {
              if (!recordingMute) {
                localAudioTrackAgora.setEnabled(true);
              }
              setWebAsstSelfMute?.(false);
            } else {
              localAudioTrackAgora.setEnabled(true);
              socketRef.current.emit(USER_UNMUTE, sessionIdRef.current);
            }
          }
        } else {
          if (socketRef && socketRef.current) {
            if (window.location.pathname.includes("webassistantcall")) {
              if (!recordingMute) {
                localAudioTrackAgora.setEnabled(false);
              }
              setWebAsstSelfMute?.(true);
            } else {
              localAudioTrackAgora.setEnabled(false);
              socketRef.current.emit(USER_MUTE, sessionIdRef.current);
            }
          }
        }
      }
      setIsMuted(!isMuted);
      if (window.location.pathname.includes("webassistantcall")) {
        if (!isMuted) {
          sessionStorage.setItem("wastSelfMuted", JSON.stringify(true));
          socketRef.current.emit(WEB_ASSISTANT_MUTE, sessionIdRef.current);
        } else if (isMuted) {
          sessionStorage.setItem("wastSelfMuted", JSON.stringify(false));
          socketRef.current.emit(WEB_ASSISTANT_UNMUTE, sessionIdRef.current);
        }
      }
    }
  };

  return (
    <IconButton
      aria-label={isVideo ? 'video' : 'audio'}
      size="small"
      onClick={toggleHandler}
      className="custom-default"
      color="default"
    >
      {isVideo ? (isVideoOff ? <VideocamOffIcon /> : <VideocamIcon />) :
        (isMuted ? <MicOffIcon /> : <MicIcon />)
      }
    </IconButton>
  );
};

export default ToggleComponent;
